import React from 'react'
import { MenuItemType } from '@utils/types'
import { WImage, EditableTitle, WLink } from '@components/atoms'
import styles from './SimpleCard.module.sass'

interface Props {
  item: MenuItemType
  size?: 'lg' | 'md' | 'sm'
  mobileSize?: 'lg' | 'md' | 'sm'
  editMode?: boolean
  className?: string
  onClick?: () => void
}

const SimpleCard = (props: Props) => {
  const {
    item = undefined,
    size = 'md',
    mobileSize = undefined,
    editMode = false,
    className = '',
    onClick = undefined,
  } = props

  const classNames = `${styles.root} ${styles[`root--${size}`]} ${
    styles[`root--mobile-${mobileSize || size}`]
  } ${item?.url ? styles['root--link'] : ''} ${
    editMode ? styles['root--editMode'] : ''
  } ${className}`
  const getContent = () => (
    <>
      <div className={`${styles.imageBox}`}>
        {!!item.image && (
          <WImage
            src={item.image}
            maxWidth={size === 'md' ? 490 : 610}
            maxHeight={size === 'md' ? 350 : 380}
            objectFit="cover"
            alt={item.imageAlt}
            title={item.imageAlt}
          />
        )}
      </div>
      <EditableTitle title={item.name} variant="h3" className={styles.title} editMode={editMode} />
    </>
  )

  return item ? (
    item.url ? (
      <WLink href={item.url} newPage={item.blank} className={classNames} onClick={onClick}>
        {getContent()}
      </WLink>
    ) : (
      <div className={classNames}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default SimpleCard
